import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { cn } from "~/lib/utils";

/**
 * The EZSpot service area as a map: the market outline over Mapbox's
 * monochrome base, filled just enough to read as ours while leaving the street
 * grid legible underneath. Shown wherever the site says "we're not there yet"
 * and needs to show where it is instead.
 *
 * `public/coverage-sf.png` is baked from `SERVICE_AREA_POLYGONS` by the mobile
 * repo's `pnpm generate:coverage-map`, then copied here — the same asset in
 * both clients, from one script and one set of polygons. Editing the polygons
 * in `~/lib/service-area` means regenerating there and re-copying, by hand;
 * nothing checks it.
 */
export function CoverageMap(t0) {
  const $ = _c(5);
  const {
    size,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("rounded-full bg-neutral-100 object-cover", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== size || $[3] !== t1) {
    t2 = <Image src="/coverage-sf.png" alt="Map of where EZSpot operates" width={size} height={size} className={t1} />;
    $[2] = size;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}